export default __webpack_public_path__ + "maps-guides-styles-layers-line-layer-960-53058d0c3eb8f7da09275072597f218c.webp";